import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { AutoGlowBrand } from "./components/AutoGlowLogo";
import ThemeSwitch from "./components/ThemeSwitch";
import { ArrowClockwise, ChatTeardropDots, ArrowLeft, ShieldCheck } from "@phosphor-icons/react";

/**
 * Página de cancelación de Stripe Checkout.
 * Se muestra cuando el usuario cierra/cancela la pasarela sin completar el pago.
 */
export default function BillingCancel() {
  return (
    <div className="min-h-screen bg-[var(--ag-midnight)] text-[var(--ag-text)] grid place-items-center px-4 py-12">
      <div className="fixed top-4 right-4 z-50"><ThemeSwitch /></div>
      <div className="max-w-lg w-full">
        <div className="flex items-center justify-center mb-6">
          <AutoGlowBrand size={26} />
        </div>
        <div className="bg-[var(--ag-midnight-soft)] border border-[var(--ag-border)] rounded-md p-8 text-center" data-testid="billing-cancel-card">
          <div className="w-16 h-16 rounded-full bg-amber-500/10 border border-amber-400/30 mx-auto grid place-items-center">
            <ChatTeardropDots size={28} weight="duotone" className="text-amber-400" />
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tighter mt-5">Pago no completado</h1>
          <p className="text-sm text-[var(--ag-text-dim)] mt-3">
            Has salido de la pasarela de pago sin finalizar tu suscripción a AutoGlow.
            Tu cuenta sigue intacta — puedes intentarlo de nuevo cuando quieras.
          </p>

          <div className="mt-6 flex flex-col gap-2 items-stretch">
            <Link to="/billing" className="block">
              <Button className="w-full ag-btn-gold h-11" data-testid="billing-retry-btn">
                <ArrowClockwise size={15} weight="bold" className="mr-1.5" /> Volver e intentarlo de nuevo
              </Button>
            </Link>
            <Link to="/" className="block">
              <Button variant="outline" className="w-full h-10 rounded-sm" data-testid="billing-home-btn">
                <ArrowLeft size={14} className="mr-1.5" /> Volver al panel
              </Button>
            </Link>
          </div>

          <div className="mt-6 pt-5 border-t border-[var(--ag-border)] text-left text-xs text-[var(--ag-text-dim)] space-y-2">
            <div className="flex items-start gap-2">
              <ShieldCheck size={14} weight="duotone" className="text-emerald-400 mt-0.5 shrink-0" />
              <p>No se ha realizado ningún cargo en tu tarjeta. Si tienes dudas o problemas con el pago, escríbenos a <a href="mailto:soporte@autoglow.app" className="underline text-[var(--ag-gold)]">soporte@autoglow.app</a> y te ayudamos en menos de 24 h.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
